// extracted by mini-css-extract-plugin
module.exports = {"file":"AttachmentsList_file__sK66H"};